import {AssignmentDetail} from '../../domain/scan/entities/AssignmentDetail';

interface AssignmentDetailResponse {
  id: number;
  benefit_id: number;
  benefit_description: string | null;
  case_user_id: number;
  case_data: string | null;
  status: number;
  recurrence: number;
  delivery_count: number | null;
  deliveries_completed: number;
  deliveries_remaining: number;
  start_date: string;
  end_date: string;
  created_at: string;
  created_by_id: number;
  updated_at: string;
  updated_by_id: number | null;
  deleted: boolean;
  deleted_at: string | null;
}

/**
 * Maps assignment detail response from API to AssignmentDetail entity
 * @param response - Assignment detail response from API
 * @returns AssignmentDetail entity
 */
export const mapAssignmentDetailResponse = (
  response: AssignmentDetailResponse,
): AssignmentDetail => {
  return {
    id: response.id,
    benefitId: response.benefit_id,
    benefitDescription: response.benefit_description,
    caseUserId: response.case_user_id,
    caseData: response.case_data,
    status: response.status,
    recurrence: response.recurrence,
    deliveryCount: response.delivery_count,
    deliveriesCompleted: response.deliveries_completed,
    deliveriesRemaining: response.deliveries_remaining,
    startDate: new Date(response.start_date),
    endDate: new Date(response.end_date),
    createdAt: new Date(response.created_at),
    createdById: response.created_by_id,
    updatedAt: new Date(response.updated_at),
    updatedById: response.updated_by_id,
    deleted: response.deleted,
    deletedAt: response.deleted_at ? new Date(response.deleted_at) : null,
  };
};
